import React, { Component } from 'react';
import styled from 'react-emotion';
import throttle from 'lodash.throttle';
import GatsbyConfig from '../../gatsby-config';

import { backgroundColor, fontFamilyStack, mqRuleAboveMobile, textColor } from '../styles';
import { scrollToElement } from '../utils';

const boxShadow = 'box-shadow: 0 4px 6px rgba(0, 0, 0, 0.125);'

const Wrapper = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;
  background: ${backgroundColor};
  font-family: ${fontFamilyStack};
  transition: box-shadow 200ms ease-in-out;
  ${boxShadow}

  @media ${mqRuleAboveMobile} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 5;
    padding-top: 8px;
    padding-bottom: 8px;
    flex-direction: row;
    box-shadow: none;
    ${props => props.scrolled ? boxShadow : ''}
  }
`;

const Title = styled.a`
  display: inline-block;
  margin-bottom: 5px;
  color: ${textColor};
  text-decoration: none;
  font-size: 20px;
  font-weight: 600;

  @media ${mqRuleAboveMobile} {
    margin-bottom: 0;
  }
`;

const NavLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media ${mqRuleAboveMobile} {
    flex-direction: row;
  }
`;

const NavLink = styled.a`
  display: inline-block;
  margin-top: 5px;
  color: ${textColor};
  letter-spacing: 1px;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;

  @media ${mqRuleAboveMobile} {
    padding: 15px;
    margin: 0 0 0 15px;
    flex-direction: row;
  }
`;

const SCROLL_DURATION = 300;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { scrolled: false };
  }

  componentDidMount() {
    window.addEventListener('scroll', throttle(this.handleScroll, 50));
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', throttle(this.handleScroll, 50));
  }

  handleScroll = () => {
    const scrollPos = typeof window.scrollY === 'number' ?
      window.scrollY :
      document.documentElement.scrollTop;
    if (scrollPos === 0 && this.state.scrolled) {
      this.setState({ scrolled: false });
    }
    else if (scrollPos > 0 && !this.state.scrolled) {
      this.setState({ scrolled: true });
    }
  }

  handleClickLink = (id, evt) => {
    evt.preventDefault();
    const target = document.getElementById(id);
    if (target) {
      const offset = window.ontouchstart ? 0 : -60;
      scrollToElement(target, SCROLL_DURATION, offset);
    }
  }

  // From https://stackoverflow.com/a/39494245
  handleClickFooterLink = (evt) => {
    evt.preventDefault();
    const startingY = window.pageYOffset;
    const windowHeight = document.documentElement.offsetHeight;
    const diff = windowHeight - startingY;
    let start;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const time = timestamp - start;
      const percent = Math.min(time / SCROLL_DURATION, 1);
      window.scrollTo(0, startingY + diff * percent);

      if (time < SCROLL_DURATION) {
        window.requestAnimationFrame(step);
      }
    };

    // Bootstrap our animation
    window.requestAnimationFrame(step);
  }

  render() {
    return (
      <Wrapper scrolled={this.state.scrolled}>
        <Title href='/' children={GatsbyConfig.siteMetadata.title} />
        <NavLinkContainer>
          <NavLink href='' onClick={this.handleClickLink.bind(this, 'section0')}>The Specifics of the Path</NavLink>
          <NavLink href='' onClick={this.handleClickLink.bind(this, 'section1')}>Your Action Plan</NavLink>
          <NavLink href='' onClick={this.handleClickFooterLink}>Connect</NavLink>
        </NavLinkContainer>
      </Wrapper>
    );
  }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js